import { AWAssetDto } from '@api/Api';
import Loader from '@components/Loader';
import { assetPreviewThumbnails } from '@helpers/assetPreviewThumbnails';
import classNames from 'classnames';
import React, { memo, useMemo } from 'react';
import { ReactComponent as LockSvg } from '@assets/icons/lock.svg';

type AssetsCellProps = {
  assets: AWAssetDto[];
};

function Asset({ asset }: { asset: AWAssetDto }) {
  const preparePreview = useMemo(() => {
    return assetPreviewThumbnails({
      url: asset?.previewUrl || '',
      status: 'ready',
      type: asset.type,
      size: 40,
      format: 'svg'
    });
  }, [asset]);

  return (
    <div
      className={classNames('assets-cell_asset', {
        'assets-cell_asset--disabled': asset.accessDisabled
      })}
    >
      <div className="assets-cell_asset-lock-icon">
        <LockSvg />
      </div>
      {preparePreview === 'pending' && (
        <Loader spinSize={40} isSpinning={true} />
      )}
      {preparePreview !== 'pending' && typeof preparePreview === 'string' ? (
        <img src={preparePreview || ''} alt="" />
      ) : (
        preparePreview
      )}
    </div>
  );
}

export default memo(function AssetsCell({ assets }: AssetsCellProps) {
  const _assets = assets.slice(0, 2);
  const assetCountLeft = assets.length - 2;
  return (
    <div className="assets-cell">
      {assetCountLeft > 0 && (
        <div className="assets-cell_count">+{assetCountLeft}</div>
      )}
      {_assets.map((asset) => (
        <Asset key={asset.id} asset={asset} />
      ))}
    </div>
  );
});
